import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { BulkActionConfirmationDialog } from './BulkActionConfirmationDialog';
import { useStatePtr } from '@pure-ptr/react';

interface BulkActionWrapperProps {
    pageName: string;
    actionLabel: string;
    onConfirm: (processAll: boolean, selectedIds: any[]) => void;
    children: (onClick: () => void) => React.ReactNode;
    title?: string;
    customText?: string;
    isPending?: boolean;
    infoMessage?:any
}

export const BulkActionWrapper = ({
    pageName,
    actionLabel,
    onConfirm,
    children,
    title,
    customText,
    infoMessage=undefined,
    isPending
}: BulkActionWrapperProps) => {
    const [open, setOpen] = useState(false);
    const processAllPtr = useStatePtr(false);
    
    const selectedIds = useSelector((state: any) => state.pagesV2[pageName]?.selected || []);
    const totalCount = useSelector((state: any) => state.pages[pageName]?.page?.totalRecords || 0);
    const currentPageCount = useSelector((state: any) => state.pages[pageName]?.list?.length || 0);

    const prevPending = React.useRef(isPending);

    React.useEffect(() => {
        if (prevPending.current && isPending === false && open) {
            setOpen(false);
        }
        prevPending.current = isPending;
    }, [isPending, open]);

    const handleOpen = () => {
        if (selectedIds.length === 0) {
            // Still open to show "Please select records" message
            setOpen(true);
            return;
        }
        processAllPtr.set(false);
        setOpen(true);
    };

    const handleConfirm = (processAll: boolean) => {
        if (isPending === undefined) {
             setOpen(false);
        }
        onConfirm(processAll, selectedIds);
    };

    return (
        <>
            {children(handleOpen)}
            <BulkActionConfirmationDialog
                infoMessage={infoMessage}
                open={open}
                onClose={() => setOpen(false)}
                onConfirm={handleConfirm}
                title={title || actionLabel}
                actionLabel={actionLabel}
                selectedCount={selectedIds.length}
                totalCount={totalCount}
                currentPageCount={currentPageCount}
                processAllPtr={processAllPtr}
                customText={customText}
                isPending={isPending}
            />
        </>
    );
};
